<template>
  <!-- Fireflies background -->
  <div class="login-page">
    <div class="firefly" v-for="n in 15" :key="n"></div>

    <div class="flexbox-container">
      <div class="box1" />

      <div class="box2">
        <div class="flexbox-card">
          <div class="card-body fireflies-color">
            <div class="orion-logo" />
            <div class="orion-title">.:: Welcome to ORION ::.</div>
            <hr class="garis" />

            <q-form @submit.prevent="onSubmit" class="login-form">
              <q-input

                color="primary"
                dense
                filled
                dark
                v-model="username"
                type="text"
                label="Username"
                autocomplete="username"
                class="q-mb-md q-pt-lg"
                :disable="loading"
                :rules="[(val) => !!val || 'Required']"
                input-class="text-white"
              />

              <q-input
                dense
                filled
                dark
                v-model="password"
                :type="isPwd ? 'password' : 'text'"
                label="Password"
                autocomplete="current-password"
                class="q-mb-sm"
                :disable="loading"
                :rules="[(val) => !!val || 'Required']"
                input-class="text-white"
              >
                <template #append>
                  <q-icon
                    :name="isPwd ? 'visibility' : 'visibility_off'"
                    class="cursor-pointer"
                    @click="isPwd = !isPwd"
                  />
                </template>
              </q-input>



              <q-btn
                type="submit"
                color="primary"
                text-color="black"
                :loading="loading"
                class="full-width q-mt-sm"
              >
                <span class="q-px-sm">Sign in</span>
              </q-btn>

              <div v-if="error" class="error-text q-mt-sm">{{ error }}</div>
            </q-form>
          </div>
        </div>
      </div>

      <div class="box3">
        <div class="flexbox-quote">
          <div class="quote fireflies-color" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useAuth } from 'stores/auth-store'
import { useRoute, useRouter } from 'vue-router'
import { useQuasar } from 'quasar'

const $q = useQuasar()

const auth = useAuth()
const route = useRoute()
const router = useRouter()

// Form state
const username = ref('')
const password = ref('')
const loading = ref(false)

// UI state used in template
const isPwd = ref(true) // toggle password visibility
const operator = ref(null) // selected operator (if applicable)
// Provide a small set of sensible defaults for operator options.
// Adjust these to match your backend values if needed.
const operatorOpts = ref([
  { label: 'Operator A', value: 'op_a' },
  { label: 'Operator B', value: 'op_b' },
])

// Error message displayed below the form (optional)
const error = ref('')

async function onSubmit() {
  loading.value = true
  error.value = ''
  try {
    await auth.login(username.value, password.value)
    // Login sudah otomatis memanggil fetchMe() di store
    // Redirect setelah login sukses
    const redirectPath = typeof route.query.redirect === 'string' ? route.query.redirect : null
    if (redirectPath && !redirectPath.startsWith('/login')) {
      await router.push(redirectPath)
    } else {
      await router.push({ name: 'home' })
    }
  } catch (e) {
    // Show both a notification and inline error text to improve UX
    const msg = (e?.response?.data?.detail) || 'Login gagal. Cek username/password.'
    error.value = msg
    $q.notify({ type: 'negative', message: msg })
  } finally {
    loading.value = false
  }
}
</script>

<style src="../assets/borobudur.css"></style>

<style lang="scss">
// /* Minimal layout to mimic nms_loginnormal.html when combined with borobudur.css */
// .login-page {
//   min-height: 100vh;
//   width: 100%;
//   overflow: hidden;
// }

// .flexbox-container {
//   position: relative;
//   min-height: 100vh;
//   display: grid;
//   grid-template-columns: 1fr minmax(320px, 440px) 1fr;
//   align-items: center;
//   justify-items: center;
//   padding: 24px;
//   // z-index: 100;
// }



.flexbox-card {
  width: 315px; /* 90% of 350px */
  max-width: 396px; /* 90% of 440px */
  border-radius: 14px; /* 90% of 16px */
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.35);
  backdrop-filter: blur(2px);
  background: rgba(0, 0, 0, 0.2);
}
.card-body {
  padding: 22px 22px 16px; /* 90% of 24px 24px 18px */
  background: rgba(0, 0, 0, 0.35);
  border-radius: 14px; /* 90% of 16px */
}



.fireflies-color {
  color: #fff;
}

.orion-logo {
  width: 72px; /* 90% of 80px */
  height: 72px; /* 90% of 80px */
  margin: 0 auto 11px; /* 90% of 12px */
  /* Use relative path so the CSS loader resolves the file correctly from this component's location */
  background: url('../assets/quasar-logo.png') center/contain no-repeat; /* placeholder — swap with your logo */
  filter: drop-shadow(0 4px 10px rgba(0, 0, 0, 0.5));
  /* filter: invert(1) brightness(2); */
}
.orion-title {
  text-align: center;
  font-weight: 400;
  letter-spacing: 0.06em;
  font-size: 1.08rem; /* 90% of 1.2rem */
  /* text-transform: uppercase; */
}
.garis {
  border: none;
  height: 1px;
  background: rgba(255, 255, 255, 0.25);
  margin: 9px 0 16px; /* 90% of 10px 0 18px */
}

// .login-form .q-field__control {
//   // padding-bottom: 100px;
//   // background: rgba(255, 255, 255, 0.08);
// }

.login-form{
padding-bottom: 90px; // 90% of 100px

}
.error-text {
  color: #ffb4a9;
}

// /* Side quote area */
// .flexbox-quote {
//   position: relative;
//   width: 100%;
//   height: 100%;
// }

/* Responsive */
// @media (max-width: 1024px) {
//   .flexbox-container {
//     grid-template-columns: 1fr;
//     gap: 24px;
//   }
//   .box1,
//   .box3 {
//     display: none;
//   }
// }
</style>
